import { getCurrentInstance } from '@vue/runtime-core'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useEmitter() {
  const internalInstance = getCurrentInstance()
  const emitter = internalInstance?.appContext.config.globalProperties.emitter

  return { emitter }
}